import './App.css';
import InputPassword from './components/InputPassword';

function App() {
  return (
    <div className="container-app">
      <h2 className="app-title">Is your password strong enough?</h2>
      <InputPassword />
    </div>
  );
}

export default App;
